/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AppLargeFooterFragmentDoc } from './AppLargeFooter.generated';
export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type AppFooterFragment = { terms: Array<{ type: Types.TermType, title: string }> };

export const AppFooterFragmentDoc = gql`
    fragment AppFooter on Query {
  ...AppLargeFooter
}
    ${AppLargeFooterFragmentDoc}`;